/**
 * 平台配置 — 对接新 Business API
 * 旧 /v1/data-dictionary 已下线，勿再请求。
 */
import { getPlatformCoin } from '@/api/config-platform';
import { getWithdrawalsConfig } from '@/api/funds';
import { minUnitToUsdt, setRuntimeJouleDecimals } from '@/common/utils/money';

/**
 * 兼容旧 configStore 的字典项形状
 */
export interface DataDictionaryItem {
  name: string;
  value: string;
  comment: string;
}

/**
 * 用 platform-coin + withdrawals/config 拼出旧字典结构，供 store 计算属性使用
 */
export const getDataDictionary = async (): Promise<DataDictionaryItem[]> => {
  const items: DataDictionaryItem[] = [];

  try {
    const coin = await getPlatformCoin();
    if (coin?.code || coin?.name) {
      items.push({
        name: 'PLATFORM_COIN_CODE',
        value: String(coin.code || coin.name || 'WATT'),
        comment: 'platform coin',
      });
    }
    if (coin?.decimals != null) {
      setRuntimeJouleDecimals(coin.decimals);
      items.push({
        name: 'PLATFORM_COIN_DECIMALS',
        value: String(coin.decimals),
        comment: 'platform coin decimals',
      });
    }
  } catch {
    // optional
  }

  try {
    const wd = await getWithdrawalsConfig();
    if (wd?.fee?.feeBps != null) {
      // 手续费使用 bps，下限由下方 minGrossAmount 换算。
      items.push({
        name: 'WITHDRAW_FEE_BPS',
        value: String(wd.fee.feeBps),
        comment: 'withdraw fee bps',
      });
    }
    if (wd?.fee?.minGrossAmount != null) {
      items.push({
        name: 'WITHDRAW_MIN_QUANTITY',
        value: minUnitToUsdt(String(wd.fee.minGrossAmount), Number(wd?.asset?.decimals ?? 18)),
        comment: 'minimum withdrawal amount in USDT',
      });
    }
  } catch {
    // 未登录或未配置时用 store 默认值
  }

  return items;
};
